module.exports = __webpack_public_path__ + "static/media/clock-orange.8835fb7f.svg";